export enum DossiersFinancementPath {
  ROOT = '',
  LISTE = 'liste',
  CREATION_CONTRAT = 'creation-contrat',
  EDITION = 'edition',
  EDITION_FACTURE = 'edition-facture',
  ID_DOSSIER_PARAM = 'idDossier',
  GENERAL_CONTRAT = 'general-contrat',
  FINANCEMENTS = 'financements',
  INSCRIPTIONS = 'inscriptions',
  DOCUMENTS = 'documents',
  TYPE_CONTRAT_PARAM = 'type-contrat',
  GENERAL_CONTRAT_SESSION = 'contrat-session',
  ID_SESSION_PARAM = 'IdSession',
  CREATION_CONTRAT_SESSION = 'creation-contrat-session',
}
